import Fade from '../common/fade/Fade';
import Cover from '../common/cover/Cover';
import Modules from '../gui/modules/Modules';
import Body from './body/Body';

export default class Leaderboard extends Phaser.GameObjects.Container {
    private fade!: Fade;
    private cover!: Cover;
    private bodyModule!: Body;

    constructor(scene: Phaser.Scene) {
        let x = scene.cameras.main.centerX;
        let y = scene.cameras.main.centerY;
        super(scene, x, y);
        this.scene.layers.popups.add(this);

        this.setupUtils();
        this.setupListeners();
    }

    setupUtils() {
        this.fade = new Fade(this.scene, 0, 0);
        this.add(this.fade);

        this.cover = new Cover(this.scene, 0, 0);
        this.add(this.cover);
    }

    setupListeners() {
        this.scene.events.on(Modules.EVENTS.SHOW_LEADERBOARD, this.show, this);
    }

    async show() {
        this.cover.show();
        await this.fade.show();

        this.bodyModule = new Body(this.scene, 0, 0);
        this.add(this.bodyModule);

        await this.bodyModule.show();
        this.cover.hide();

        this.bodyModule.once('close', this.hide, this);
    }

    async hide() {
        this.cover.show();

        await this.bodyModule.hide();
        await this.fade.hide();
        this.bodyModule.destroy();

        this.cover.hide();
    }

    destroy() {
        this.scene.events.off(Modules.EVENTS.SHOW_LEADERBOARD, this.show, this);
        super.destroy();
    }
}
